._message-ai-wrapper_ke9qb_1 {
  position: relative;
  will-change: opacity, transform;
  animation: _aiMessageEntrance_ke9qb_1 0.5s both;
  animation-delay: 0.5s; }
  ._message-ai-wrapper-first_ke9qb_6 {
    animation-delay: 0s; }

._message-ai-bg_ke9qb_9 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: height 0.2s cubic-bezier(0.33, 1, 0.68, 1);
  min-height: 67px;
  background: var(--chat-message-ai-bg-color);
  border-radius: 20px; }

@container chat (max-width: 470px) {
  ._message-ai-bg_ke9qb_9 {
    min-height: 44px; } }
  [data-theme="chat-theme-dark"] ._message-ai-bg_ke9qb_9,
  [data-theme="chat-theme-light"] ._message-ai-bg_ke9qb_9 {
    border-radius: 12px; }

@keyframes _aiMessageEntrance_ke9qb_1 {
  0% {
    opacity: 0;
    transform: translateY(-1em); }
  100% {
    opacity: 1;
    transform: translateY(0); } }
